<template>
  <div class="header w100 df">
    <div class="header_left df">
      <img
        :src="require('@/assets/images/common/logo.png')"
        alt=""
        class="logo_img"
      />
      <span class="line"></span>
      <p>文旌 · 数字教材</p>
    </div>
    <!-- <div class="header_right df">
      <span class="h_r_title">欢迎你：{{ name }}</span>
      <span class="line"></span>
      <p class="sign_out df" @click="logout">
        <img
          :src="require('@teacherB/common/signout_default.png')"
          alt=""
        />
        退出
      </p>
    </div> -->
  </div>
</template>
   
<script>
export default {
  data() {
    return {
      
    }
  },
  created() {
    
  },
  methods: {
    
  },
};
</script>
   
<style scoped lang='scss'>
.header {
  height: 48px;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 2px 10px 0px rgba(131, 149, 255, 0.15);
  background: #fff;
  display: flex;
  .header_left {
    padding-left: 20px;
    align-items: center;
    display: flex;
    .logo_img {
      width: 114px;
    }
    .line {
      width: 2px;
      height: 20px;
      background: #2d3043;
      border-radius: 1px;
      margin: 0 20px;
    }
    p {
      font-size: 16px;
      font-weight: bold;
      color: #2d3043;
    }
  }
  .header_right {
    padding-right: 20px;
    align-items: center;
    .h_r_title {
      color: #2d3043;
      font-size: 12px;
    }
    .line {
      width: 2px;
      height: 13px;
      font-size: 12px;
      background: #b8b8bd;
      margin: 0 14px;
    }
    .sign_out {
      align-items: center;
      cursor: pointer;
      img {
        width: 12px;
        margin-right: 5px;
      }
      font-weight: 400;
      font-size: 12px;
      color: #2d3043;
    }
  }
}
</style>